import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    page_state:{
      home_custom:{
        azwz: {status: "1", name: "安裝位置", order: "1"},
        azd: {status: "1", name: "安裝到", order: "2"}
      },
      card_custom:{
        cphg: {status: "1", name: "產品合共", order: "1"},
        zk: {status: "1", name: "折扣", order: "2"},
        xj: {status: "1", name: "小計", order: "3"},
        azf: {status: "1", name: "安裝費", order: "4"},
        ysf: {status: "1", name: "運送地址/運輸費", order: "5"},
        hg: {status: "1", name: "合共", order: "6"},
        dj: {status: "1", name: "定金", order: "7"},
        yfdj: {status: "1", name: "已付定金", order: "8"},
        yk: {status: "1", name: "餘款", order: "9"},
        bz: {status: "1", name: "備註", order: "10"},
        jj: {status: "1", name: "加急", order: "11"},
        mz: {status: "1", name: "名字", order: "12"},
        dh: {status: "1", name: "電話", order: "13"},
        yx: {status: "1", name: "郵箱", order: "14"},
        azrq: {status: "1", name: "安裝日期", order: "15"},
        shdz: {status: "1", name: "收貨地址", order: "16"},
        scfj: {status: "1", name: "上傳附件", order: "17"},
      },
      order_custom: {
        dh: {
          status: '1',
          name: "单号",
          order: 1
        },
        bzh: {
          status: '1',
          name: "备注号",
          order: 2
        },
        kr: {
          status: '1',
          name: "客人",
          order: 3
        },
        tjsj: {
          status: '1',
          name: "添加时间",
          order: 4
        },
        yqsj: {
          status: '1',
          name: "要求时间",
          order: 5
        },
        htsrdwcsj: {
          status: '1',
          name: "后台输入的完成时间",
          order: 6
        },
        zdzt: {
          status: '1',
          name: "自定状态",
          order: 7
        },
        czry: {
          status: '1',
          name: "操作人员",
          order: 8
        },
        kddh: {
          status: '1',
          name: "快递单号",
          order: 9
        },
        wcsj: {
          status: '1',
          name: "完成时间",
          order: 10
        },
        xgsj: {
          status: '1',
          name: "修改时间",
          order: 11
        },
        cz: {
          status: '1',
          name: "操作",
          order: 12
        },
        dc: {
          status: '1',
          name: "导出",
          order: 13
        },
        bz: {
          status: '1',
          name: "备注",
          order: 3
        },
        fj: {
          status: '1',
          name: "附件",
          order: 14
        },
        ywydh: {status: "1", name: "業務員代號", order: "15"},
        jgsmc: {status: "1", name: "技工所名稱", order: "16"},
        amount: {status: "1", name: "AMOUNT", order: "17"},
        ddlx: {status: "1", name: "訂單類型", order: "18"},
        fwlx: {status: "1", name: "服務類型", order: "19"},
        navsono: {status: "1", name: "NAV SO no", order: "20"},
        navcustomerno: {status: "1", name: "NAV customer no", order: "21"},
        navsalename: {status: "1", name: "NAV Sale name", order: "22"},
        clinicorderamount: {status: "1", name: "Clinic order amount", order: "23"},
        labchargeamount: {status: "1", name: "Lab Charge amount", order: "24"},
        labinvno: {status: "1", name: "Lab inv no", order: "25"},
        labreferenceno: {status: "1", name: "Lab reference no", order: "26"},
        servicergarding: {status: "1", name: "Service Garding", order: "27"},
        noofym: {status: "1", name: "NO of 牙模", order: "28"},
        technicianname: {status: "1", name: "Technician name", order: "29"},
        labkddh: {status: "1", name: "Lab 快遞單號", order: "30"},
        yjwcrq: {status: "1", name: "預計完成日期", order: "31"},
        chrq: {status: "1", name: "出貨日期", order: "32"},
        htqs: {status: "1", name: "合同签署", order: "33"},
        ckd: {status: "1", name: "出库单", order: "34"},
      },
      order_custom_yg: {
        dh: {
          status: "1",
          name: "单号",
          order: 1
        },
        bzh: {
          status: "1",
          name: "备注号",
          order: 2
        },
        kr: {
          status: "1",
          name: "客人",
          order: 3
        },
        tjsj: {
          status: "1",
          name: "添加时间",
          order: 4
        },
        yqsj: {
          status: "1",
          name: "要求时间",
          order: 5
        },
        htsrdwcsj: {
          status: "1",
          name: "后台输入的完成时间",
          order: 6
        },
        zdzt: {
          status: "1",
          name: "自定状态",
          order: 7
        },
        czry: {
          status: "1",
          name: "操作人员",
          order: 8
        },
        kddh: {
          status: "1",
          name: "快递单号",
          order: 9
        },
        wcsj: {
          status: "1",
          name: "完成时间",
          order: 10
        },
        xgsj: {
          status: "1",
          name: "修改时间",
          order: 11
        },
        cz: {
          status: "1",
          name: "操作",
          order: 12
        },
        dc: {
          status: "1",
          name: "导出",
          order: 13
        },
        bz: {
          status: "1",
          name: "备注",
          order: 3
        },
        fj: {
          status: "1",
          name: "附件",
          order: 14
        },
        ywydh: {status: "1", name: "業務員代號", order: "15"},
        jgsmc: {status: "1", name: "技工所名稱", order: "16"},
        amount: {status: "1", name: "AMOUNT", order: "17"},
        ddlx: {status: "1", name: "訂單類型", order: "18"},
        fwlx: {status: "1", name: "服務類型", order: "19"},
        navsono: {status: "1", name: "NAV SO no", order: "20"},
        navcustomerno: {status: "1", name: "NAV customer no", order: "21"},
        navsalename: {status: "1", name: "NAV Sale name", order: "22"},
        clinicorderamount: {status: "1", name: "Clinic order amount", order: "23"},
        labchargeamount: {status: "1", name: "Lab Charge amount", order: "24"},
        labinvno: {status: "1", name: "Lab inv no", order: "25"},
        labreferenceno: {status: "1", name: "Lab reference no", order: "26"},
        servicergarding: {status: "1", name: "Service Garding", order: "27"},
        noofym: {status: "1", name: "NO of 牙模", order: "28"},
        technicianname: {status: "1", name: "Technician name", order: "29"},
        labkddh: {status: "1", name: "Lab 快遞單號", order: "30"},
        yjwcrq: {status: "1", name: "預計完成日期", order: "31"},
        chrq: {status: "1", name: "出貨日期", order: "32"},
        htqs: {status: "1", name: "合同签署", order: "33"},
        ckd: {status: "1", name: "出库单", order: "34"},
      },
      order_custom_gys: {
        dh: {
          status: "1",
          name: "单号",
          order: 1
        },
        bzh: {
          status: "1",
          name: "备注号",
          order: 2
        },
        kr: {
          status: "1",
          name: "客人",
          order: 3
        },
        tjsj: {
          status: "1",
          name: "添加时间",
          order: 4
        },
        yqsj: {
          status: "1",
          name: "要求时间",
          order: 5
        },
        htsrdwcsj: {
          status: "1",
          name: "后台输入的完成时间",
          order: 6
        },
        zdzt: {
          status: "1",
          name: "自定状态",
          order: 7
        },
        czry: {
          status: "1",
          name: "操作人员",
          order: 8
        },
        kddh: {
          status: "1",
          name: "快递单号",
          order: 9
        },
        wcsj: {
          status: "1",
          name: "完成时间",
          order: 10
        },
        xgsj: {
          status: "1",
          name: "修改时间",
          order: 11
        },
        cz: {
          status: "1",
          name: "操作",
          order: 12
        },
        dc: {
          status: "1",
          name: "导出",
          order: 13
        },
        bz: {
          status: "1",
          name: "备注",
          order: 3
        },
        fj: {
          status: "1",
          name: "附件",
          order: 14
        },
        ywydh: {status: "1", name: "業務員代號", order: "15"},
        jgsmc: {status: "1", name: "技工所名稱", order: "16"},
        amount: {status: "1", name: "AMOUNT", order: "17"},
        ddlx: {status: "1", name: "訂單類型", order: "18"},
        fwlx: {status: "1", name: "服務類型", order: "19"},
        navsono: {status: "1", name: "NAV SO no", order: "20"},
        navcustomerno: {status: "1", name: "NAV customer no", order: "21"},
        navsalename: {status: "1", name: "NAV Sale name", order: "22"},
        clinicorderamount: {status: "1", name: "Clinic order amount", order: "23"},
        labchargeamount: {status: "1", name: "Lab Charge amount", order: "24"},
        labinvno: {status: "1", name: "Lab inv no", order: "25"},
        labreferenceno: {status: "1", name: "Lab reference no", order: "26"},
        servicergarding: {status: "1", name: "Service Garding", order: "27"},
        noofym: {status: "1", name: "NO of 牙模", order: "28"},
        technicianname: {status: "1", name: "Technician name", order: "29"},
        labkddh: {status: "1", name: "Lab 快遞單號", order: "30"},
        yjwcrq: {status: "1", name: "預計完成日期", order: "31"},
        chrq: {status: "1", name: "出貨日期", order: "32"},
        htqs: {status: "1", name: "合同签署", order: "33"},
        ckd: {status: "1", name: "出库单", order: "34"},
      }
    },
    Order_list_fields:{
      dh: {
        status: "1",
        name: "单号",
        order: 1
      },
      bzh: {
        status: "1",
        name: "备注号",
        order: 2
      },
      kr: {
        status: "1",
        name: "客人",
        order: 3
      },
      tjsj: {
        status: "1",
        name: "添加时间",
        order: 4
      },
      yqsj: {
        status: "1",
        name: "要求时间",
        order: 5
      },
      htsrdwcsj: {
        status: "1",
        name: "后台输入的完成时间",
        order: 6
      },
      zdzt: {
        status: "1",
        name: "自定状态",
        order: 7
      },
      czry: {
        status: "1",
        name: "操作人员",
        order: 8
      },
      kddh: {
        status: "1",
        name: "快递单号",
        order: 9
      },
      wcsj: {
        status: "1",
        name: "完成时间",
        order: 10
      },
      xgsj: {
        status: "1",
        name: "修改时间",
        order: 11
      },
      cz: {
        status: "1",
        name: "操作",
        order: 12
      },
      dc: {
        status: "1",
        name: "导出",
        order: 13
      },
      bz: {
        status: "1",
        name: "备注",
        order: 3
      },
      fj: {
        status: "1",
        name: "附件",
        order: 14
      },
      ywydh: {status: "1", name: "業務員代號", order: "15"},
      jgsmc: {status: "1", name: "技工所名稱", order: "16"},
      amount: {status: "1", name: "AMOUNT", order: "17"},
      ddlx: {status: "1", name: "訂單類型", order: "18"},
      fwlx: {status: "1", name: "服務類型", order: "19"},
      navsono: {status: "1", name: "NAV SO no", order: "20"},
      navcustomerno: {status: "1", name: "NAV customer no", order: "21"},
      navsalename: {status: "1", name: "NAV Sale name", order: "22"},
      clinicorderamount: {status: "1", name: "Clinic order amount", order: "23"},
      labchargeamount: {status: "1", name: "Lab Charge amount", order: "24"},
      labinvno: {status: "1", name: "Lab inv no", order: "25"},
      labreferenceno: {status: "1", name: "Lab reference no", order: "26"},
      servicergarding: {status: "1", name: "Service Garding", order: "27"},
      noofym: {status: "1", name: "NO of 牙模", order: "28"},
      technicianname: {status: "1", name: "Technician name", order: "29"},
      labkddh: {status: "1", name: "Lab 快遞單號", order: "30"},
      yjwcrq: {status: "1", name: "預計完成日期", order: "31"},
      chrq: {status: "1", name: "出貨日期", order: "32"},
      htqs: {status: "1", name: "合同签署", order: "33"},
      ckd: {status: "1", name: "出库单", order: "34"},
    },//訂單列表字段的顯示和隱藏
    phoneCode:'',
    loginphone:'',
    viewDirection: '',
    i_id : 0,
    shippingcost:0,
    InstallMode:0,
    urgent:false,
    userdata:{
      name:'',
      phone:'',
      email:'',
      datevalue:'',
      Deliverytime:'',
      time_type:0,
      Receivingaddress:'',
      latLngData:'',
      Paymentmethod:sessionStorage.getItem('order_id'),
      installationfee:[],
      collecting:'', //是否收牙模
      gender:'', //性別
      age:'', //年齡
      operator:'', //操作人
      user_real_name:'', //用户真实姓名
      dentist_name:'', //另外的用户真实姓名
      dentist_name_id:'', //另外的用户id
      customer_id:'', //客戶公司ID
    },
    loginuserdata:{},
    inorderilstroutername:'index',
    client:true,
    orderdiscount:0, //订单折扣
    approval_discount: '', //审批折扣
    orderdiscount_id:'', //订单折扣id
    quotation_code:'', //订单单号
    remark:'', //订单备注
    defaultAttributeValue:[],
    deposit_amount:0,
    payment_record:[], //订单支付定金列表
    quotation_ifshow:'1',
    signature_status:0,//签名状态
    send_mail_flag:0,
    enclosure:[], //附件
    freight:[], //运输费id
    file:{
      name:''
    },
    system:'', //安裝位置備註
    install_canvas:'', //安裝位置圖片
    delivery_method:'', //送貨方式id
    delivery_time_value:0, //送貨所需天數
    list_class:1, //當前賬戶的身份

    fast_odd_numbers:'', //快遞單號
    backstage_completion_time:'', //預計完成時間
    shipping_date:'', //出貨日期
    remarks:'', //訂單備註
    // 內頁新增字段
    our_remarks:'',  // 我方备注
    salesperson_id:'',  // 销售员ID(用戶)
    custom_amount:'',  // 金额
    charge_amount:'',  // 加工费or运输费
    your_remarks:'',  // 供方备注
    reference_number:'',  //  Lab编号 lab reference no
    service_grade:'',  //  服务等级
    dental_model_quantity:'',  //no of 牙模
    technician_name:'',  // Technician name
    courier_odd_numbers:'',  // Lab快递单号
    user_remarks_number:'',  // NAV customer no

    search_status: '', //搜索狀態
    search_date_h: '', //搜索的開始時間
    search_date_end: '', //搜索的結束時間
    key_word: '', //搜索的關鍵字
    search_type: [], //搜索的類型

    // 生產訂單新增字段
    Production_order_No:'',
    create_time:'', //訂單日期
  },
  mutations: {
    set_create_time (state, str) {
      state.create_time = str
    },
    set_our_remarks (state, str) {
      state.our_remarks = str
    },
    set_salesperson_id (state, str) {
      state.salesperson_id = str
    },
    set_custom_amount (state, str) {
      state.custom_amount = str
    },
    set_charge_amount (state, str) {
      state.charge_amount = str
    },
    set_your_remarks (state, str) {
      state.your_remarks = str
    },
    set_reference_number (state, str) {
      state.reference_number = str
    },
    set_service_grade (state, str) {
      state.service_grade = str
    },
    set_dental_model_quantity (state, str) {
      state.dental_model_quantity = str
    },
    set_technician_name (state, str) {
      state.technician_name = str
    },
    set_courier_odd_numbers (state, str) {
      state.courier_odd_numbers = str
    },
    set_user_remarks_number (state, str) {
      state.user_remarks_number = str
    },
    // 搜索
    set_search_status (state, str) {
      state.search_status = str
    },
    set_search_date_h (state, str) {
      state.search_date_h = str
    },
    set_search_date_end (state, str) {
      state.search_date_end = str
    },
    set_key_word (state, str) {
      state.key_word = str
    },
    set_search_type (state, str) {
      state.search_type = str
    },
    // 訂單列表字段的顯示和隱藏
    set_Order_list_fields (state, str) {
      state.Order_list_fields = str
    },
    //訂單備註
    set_remarks (state, str) {
      state.remarks = str
    },
    //出貨日期
    set_shipping_date (state, date) {
      state.shipping_date = date
    },
    //預計完成時間
    set_backstage_completion_time (state, date) {
      state.backstage_completion_time = date
    },
    //快遞單號
    set_fast_odd_numbers (state, number) {
      state.fast_odd_numbers = number
    },
    //當前賬戶的身份
    set_list_class (state, number) {
      state.list_class = number
    },
    //頁面的字段顯示和隱藏狀態
    set_page_state (state, obj) {
      state.page_state = obj
    },
    //上传文件
    set_file (state, obj) {
      state.file = obj
    },
    //送貨方式
    set_delivery_method (state, str) {
      state.delivery_method = str
    },
    //送貨所需天數
    set_delivery_time_value (state, str) {
      state.delivery_time_value = str
    },
    //安裝位置備註
    set_system (state, str) {
      state.system = str
    },
    //默认属性值
    set_defaultAttributeValue (state, arr) {
      state.defaultAttributeValue = arr
    },
    //订单折扣
    set_orderdiscount (state, num) {
      state.orderdiscount = num
    },
    //审批折扣
    set_approval_discount (state, num) {
      state.approval_discount = num
    },
    //订单折扣id
    set_orderdiscount_id (state, str) {
      state.orderdiscount_id = str
    },
    //订单单号
    set_quotation_code (state, str) {
      state.quotation_code = str
    },
    //send_mail_flag
    set_send_mail_flag (state, num) {
      state.send_mail_flag = num
    },
    //订单状态
    set_quotation_ifshow (state, num) {
      state.quotation_ifshow = num
    },
    //订单状态
    set_signature_status (state, boer) {
      state.signature_status = boer
    },
    //订单支付定金列表
    set_payment_record (state, arr) {
      state.payment_record = arr
    },
    //订单备注
    set_remark (state, str) {
      state.remark  = str
    },
    //定金价格
    set_deposit_amount (state, num) {
      state.deposit_amount = num
    },
    // 判断用户是移动端还是pc端
    set_client (state, booler) {
      state.client = booler
    },
    // 电话区号
    set_phoneCode (state, str) {
      state.phoneCode =str
    },
    // 登录时的手机号码
    set_loginphone (state, str) {
      state.loginphone =str
    },
    // 登录后存储用户数据
    set_loginuserdata (state, obj) {
      state.loginuserdata = obj
    },
    //
    set_shippingcost (state, num) {
      state.shippingcost = Number.parseFloat(num)
    },
    //安装方式
    set_InstallMode (state, num) {
      state.InstallMode = Number.parseFloat(num)
    },
    seti_id (state, str) {
      state.i_id = str
    },
    set_install_canvas (state, base64) {
      state.install_canvas = base64
    },
    setname (state, str) {
      state.userdata.name = str
    },
    set_age (state, str) {
      state.userdata.age = str
    },
    //操作人
    set_operator (state, str) {
      state.userdata.operator = str
    },
    //用户真实姓名
    set_user_real_name (state, str) {
      state.userdata.user_real_name = str
    },
    //另外的用户真实姓名
    set_dentist_name (state, str) {
      state.userdata.dentist_name = str
    },
    //另外的用户id
    set_dentist_name_id (state, str) {
      state.userdata.dentist_name_id = str
    },
    //客戶公司ID
    set_customer_id (state, str) {
      state.userdata.customer_id = str
    },
    //性別
    set_gender (state, str) {
      state.userdata.gender = str
    },
    //是否收牙模
    set_collecting (state, str) {
      state.userdata.collecting = str
    },
    //订单提交时的手机号码
    setphone (state, str) {
      state.userdata.phone = str
    },
    //订单提交时的邮箱
    setemail (state, str) {
      state.userdata.email = str
    },
    //安装日期和时间点或时间段
    setDeliverytime (state, obj) {
      if (obj.time || obj.time === ''){
        state.userdata.Deliverytime = obj.time
      }
      if (obj.time_type || obj.time_type === ''){
        state.userdata.time_type = obj.time_type
      }
      if (obj.datevalue || obj.datevalue === ''){
        state.userdata.datevalue = obj.datevalue
      }
    },
    //安装费
    setinstallationfee (state, arr) {
      state.userdata.installationfee = arr
    },
    //运输费id
    set_freight (state, arr) {
      state.freight = arr
    },
    // 订单附件
    set_enclosure (state, arr) {
      state.enclosure = arr
    },
    //收货地址和地址的经纬度
    setReceivingaddress (state, obj) {
      state.userdata.Receivingaddress = obj.address
      state.userdata.latLngData = obj.latLngData
    },
    //订单是否已经提交
    setPaymentmethod (state, str) {
      state.userdata.Paymentmethod = str
    },
    //是否加急
    set_urgent (state, str) {
      state.urgent = str
    },
    //保存进入订单列表的路由
    set_inorderilstroutername (state, str) {
      state.inorderilstroutername = str
    },
    //初始化数据
    res_state(state){
      state.viewDirection=''
      state.i_id = 0
      state.shippingcost=0
      state.InstallMode=0
      state.urgent = false
      state.orderdiscount = 0 //订单折扣
      state.orderdiscount_id = '' //订单折扣id
      state.deposit_amount = 0 //定金金额
      state.quotation_ifshow = '1' //订单状态
      state.signature_status = 0 //签名状态
      state.send_mail_flag = 0 //是否发送邮件标识
      state.file = {name:''}
      state.enclosure = [] //附件
      state.freight = [] //运输费id
      state.remark = '' //订单备注
      state.payment_record = [] //订单支付定金列表
      state.userdata = {
        name:'',
        phone:'',
        email:'',
        datevalue:'',
        Deliverytime:'',
        time_type:0,
        Receivingaddress:'',
        Paymentmethod:null,
        installationfee:[],
        gender:'',
        age:'',
        operator:'', //操作人
        dentist_name:'', //另外的用户真實姓名
        dentist_name_id:'', //另外的用户id
        collecting:'', //是收牙模
      }
    },
    res_data(state){
      state.fast_odd_numbers=''
      state.backstage_completion_time = ''
      state.shipping_date=''
      state.remarks=''
      state.our_remarks = ''
      state.salesperson_id = ''
      state.custom_amount = ''
      state.charge_amount = ''
      state.your_remarks = ''
      state.reference_number = ''
      state.service_grade = ''
      state.dental_model_quantity = ''
      state.technician_name = ''
      state.courier_odd_numbers = ''
      state.user_remarks_number = ''
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js